import { Link } from 'gatsby';
import styled from 'styled-components';
import { Text } from '../TypographyPublicSite';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
`;

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.palette.actionablePrimary};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.palette.actionableHover};
    text-decoration: none;
  }
`;

export const StyledSegment = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const StyledText = styled(Text)`
  letter-spacing: 1px;
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.sm.fontSize};

  @media (min-width: ${({ theme }) => theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.sm.fontSize};
  }
`;
